import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stock-historico',
  templateUrl: './stock-historico.component.html',
  styleUrls: ['./stock-historico.component.css']
})
export class StockHistoricoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/stock-historico/stock-historico.component.ts